import { render, staticRenderFns } from "./PreviewVpsApprovalModal.vue?vue&type=template&id=3026b2a0"
import script from "./PreviewVpsApprovalModal.vue?vue&type=script&lang=js"
export * from "./PreviewVpsApprovalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports